<template>
<div>
    <router-link :to="'/stores/update/'+row.id" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
	    <i class="fa fa-edit"></i>
    </router-link>
    <router-link :to="'/stores/'+row.id+'/products'" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
	    <i class="fab fa-product-hunt"></i>
    </router-link>
    <router-link :to="'/stores/'+row.id+'/coupons'" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
        <i class="fa fa-credit-card"></i>
    </router-link>
</div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
})
</script>

<style>

</style>